var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStartIndicator = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "-6 -6 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "start-indicator-outer-circle",
    cx: 17,
    cy: 17,
    r: 22
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "start-indicator-inner-circle",
    cx: 17,
    cy: 17,
    r: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "start-indicator-pin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8947 13.1067C23.8947 17.0317 16.9474 26.8258 16.9474 26.8258C16.9474 26.8258 10 17.0317 10 13.1067C10 9.1818 13.1104 6 16.9474 6C20.7843 6 23.8947 9.1818 23.8947 13.1067ZM20.2699 13.1067C20.2699 14.9839 18.7823 16.5056 16.9473 16.5056C15.1122 16.5056 13.6246 14.9839 13.6246 13.1067C13.6246 11.2296 15.1122 9.70786 16.9473 9.70786C18.7823 9.70786 20.2699 11.2296 20.2699 13.1067ZM14.6642 26.8876C14.357 26.8876 14.108 27.1367 14.108 27.4438C14.108 27.751 14.357 28 14.6642 28H19.3514C19.6586 28 19.9076 27.751 19.9076 27.4438C19.9076 27.1367 19.6586 26.8876 19.3514 26.8876H14.6642Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStartIndicator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/StartIndicator.685423b1ccb922fcd91a557f120b6701.svg";